export default "__VITE_ASSET__BDYk1yjG__"